import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#080808] border-t border-white/10 pt-24 md:pt-32 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-20">
          <div className="md:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#D4AF37] mb-6">
              A Young Black Man Incorporated Company
            </p>
            <h3
              data-testid="footer-wordmark"
              className="font-display text-5xl md:text-7xl lg:text-[112px] font-black tracking-tighter text-[#F4F4F0] leading-[0.92]"
            >
              Young Black Man<br />Incorporated<br />
              <span className="text-[#D4AF37]">Studios</span>
            </h3>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8 content-start md:pt-12">
            <div>
              <h4 className="text-xs font-bold uppercase tracking-[0.22em] text-[#A0A0A0] mb-5">Product</h4>
              <ul className="space-y-3 text-sm text-[#F4F4F0]/90">
                <li><a data-testid="footer-link-use-cases" href="#use-cases" className="hover:text-[#D4AF37] transition-colors">Use Cases</a></li>
                <li><a data-testid="footer-link-pricing" href="#pricing" className="hover:text-[#D4AF37] transition-colors">Pricing</a></li>
                <li><a data-testid="footer-link-faq" href="#faq" className="hover:text-[#D4AF37] transition-colors">FAQ</a></li>
                <li><Link to="/register" data-testid="footer-link-get-started" className="hover:text-[#D4AF37] transition-colors">Get Started</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-bold uppercase tracking-[0.22em] text-[#A0A0A0] mb-5">Support</h4>
              <ul className="space-y-3 text-sm text-[#F4F4F0]/90">
                <li>
                  <a
                    href="mailto:support@ybmstudios.com?subject=YBM%20Studios%20Support"
                    data-testid="footer-support-email"
                    className="hover:text-[#D4AF37] transition-colors break-all"
                  >
                    support@ybmstudios.com
                  </a>
                </li>
                <li>
                  <span data-testid="footer-link-terms" className="text-[#5A5A5A] cursor-not-allowed" title="Coming soon">
                    Terms <span className="text-[9px] uppercase tracking-wider ml-1">(soon)</span>
                  </span>
                </li>
                <li>
                  <span data-testid="footer-link-privacy" className="text-[#5A5A5A] cursor-not-allowed" title="Coming soon">
                    Privacy <span className="text-[9px] uppercase tracking-wider ml-1">(soon)</span>
                  </span>
                </li>
              </ul>
              <p className="text-[10px] uppercase tracking-[0.18em] text-[#A0A0A0] mt-5 leading-relaxed">
                Questions, billing or technical help — we reply within 24h.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-[#A0A0A0] tracking-wider">
            © {new Date().getFullYear()} Young Black Man Incorporated. All rights reserved.
          </p>
          <p className="text-xs text-[#A0A0A0] tracking-[0.2em] uppercase">
            Business-Grade AI Video · Made With Intent
          </p>
        </div>
      </div>
    </footer>
  );
}
